var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-stock-1174580",
    d: "M10.132,20.751h7.49A1.916,1.916,0,0,0,19.506,18.8V17.516a1.916,1.916,0,0,0-1.884-1.947h-7.49a1.916,1.916,0,0,0-1.884,1.947V18.8A1.916,1.916,0,0,0,10.132,20.751Zm0-6.44h7.489a1.916,1.916,0,0,0,1.884-1.947V11.076a1.916,1.916,0,0,0-1.884-1.947H10.132a1.916,1.916,0,0,0-1.884,1.947v1.288A1.916,1.916,0,0,0,10.132,14.312ZM20.8,21.99H7V11.82c0-.033-.007-.095-.007-.128a1.2,1.2,0,0,0-1.157-1.243H3.163a1.251,1.251,0,0,0-1.182,1.275,1.276,1.276,0,0,0,1.182,1.3H4.511V21.99H4.42a1.25,1.25,0,0,0-1.181,1.274,1.274,1.274,0,0,0,1.181,1.3H5.807s0,.005,0,.008a2.515,2.515,0,0,0,2.472,2.555,2.515,2.515,0,0,0,2.472-2.555s0-.005,0-.008h3.779s0,.005,0,.008a2.474,2.474,0,1,0,4.945,0s0-.005,0-.008H20.8a1.274,1.274,0,0,0,1.181-1.3A1.249,1.249,0,0,0,20.8,21.99Z",
    transform: "translate(-1.981 -9.129)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockIcon);
export default __webpack_public_path__ + "static/media/stock-icon.eb8b461f4e0fb1f32afb0e744e728f82.svg";
export { ForwardRef as ReactComponent };